import React from 'react';
import { withRouter } from 'react-router-dom'
import Navbar from "../Components/Navbar";
import Footer from "../Components/Footer";
import Swal from 'sweetalert2'
import axios from 'axios';
import { API_MOSA_URL, ACCESS_TOKEN_NAME } from '../constants/apiContants';
import LoadingOverlay from 'react-loading-overlay';
import "./Dash.css";
import "./Profile.css";

const devicedetails = {
  "imei": "862188038288320",
  "deviceOSVersion": "6.0.1",
  "uuid": "862188038288320",
  "deviceModel": "NOKIA 100",
  "deviceManufacturer": "Xiaomi",
  "serviceProvider": "airtel",
  "deviceOS": "ANDROID",
  "ipAddress": "192.168.43.210"
}
const headers = {
  "RequestMode": "0",
  "UserID": localStorage.getItem('userid'),
  "BearerKey": "Mobile",
  "ServiceId": "SERV!",
  "SessionId": localStorage.getItem(ACCESS_TOKEN_NAME),
  "Locale": "E/A",
  "DeviceDet": devicedetails

}

class Profile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      tabIndex: 0,
      events: [],
      page: 2,
      events: [],
      email: localStorage.getItem('userEmail'),
      mobile: localStorage.getItem('userPhone')
    };
    this.setState = this.setState.bind(this);
    this.setTabIndexDetails = this.setTabIndexDetails.bind(this);
    this.eventDetails = this.eventDetails.bind(this);

  }
  setTabIndexDetails = (event, index) => {
    console.log(index);
    this.setState({ tabIndex: index });
  }
  myChangeHandler = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }
  // handelOnUploadFile = (event) => {
  //   console.log("File ::: " + JSON.stringify(event.target.files[0]));
  //   this.setState({
  //     document: event.target.files[0]
  //   })
  // }
  getFiles(file) {
    this.setState({ document: file })
  }
  getFilesDoc(file) {
    this.setState({ documentId: file })
  }
  handleMembership = () => {



    const payload = {
      "membership_type": "STUDENT",
      "name": "Sreekanth",
      "nationality_id": "OMAN",
      "dob": "05/02/1990",
      "work_place": "WATTAYA",
      "occupation": "SOFTWARE ENGINEER",
      "resident_place": "RUWI",
      "mobile_no": "97009700",
      "email_id": "sree@gmail.com",
      "gender": "MALE",
      "duration": "6",
      "civil_id":""

    }

    // redirectToHome();
    const mosa = { "mast": payload, ReqHead: headers }
    // console.log('calling api ...' + JSON.stringify(payload));
    let self = this; //  declared var welcom

    console.log('calling api ...' + JSON.stringify(mosa));
    this.setState({ isActive: true });

    axios.post(API_MOSA_URL + '/User/NewMembershipInsert', mosa)
      .then(function (response) {
        console.log(JSON.stringify(response));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {
          if (response.data[0].StatusCode == "0") {
            Swal.fire({
              title: 'Success',
              text: 'Your membership request is submitted',
              icon: 'success',
              confirmButtonText: 'Ok'
            }).then((result) => {
              if (result.value) {
                localStorage.setItem('enableeditprofile', true);
                self.props.history.push('/welcome');
              }
            })
          } else {
            Swal.fire({
              title: 'Error!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }


        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });




  }
  createevent = () => {
    this.props.history.push('/createevent');

  }
  eventDetails = (e, eid, sid) => {
    this.props.history.push({
      pathname: '/details',
      state: { eventid: eid, stadiumid: sid }
    });

  }

  componentDidMount() {

    let self = this; //  declared var welcom

    this.setState({ isActive: true });
    const mosa = { ReqHead: headers }
    console.log('calling events list ....' + JSON.stringify(mosa));


    axios.post(API_MOSA_URL + '/Company/GetMyEventList', mosa)

      .then(function (response) {
        console.log(JSON.stringify(response.data));
        // self.redirectToValidate();
        self.setState({ isActive: false });

        if (response.status === 200) {

          if (response.data[0].StatusCode == "0") {

            self.setState({ events: response.data[1] });

          } else {
            Swal.fire({
              title: 'Error!',
              text: response.data[0].Message,
              icon: 'error',
              confirmButtonText: 'Ok'
            })
          }

        } else {
          Swal.fire({
            title: 'Error!',
            text: 'Please try again later!',
            icon: 'error',
            confirmButtonText: 'Ok'
          })
        }

      })
      .catch(function (error) {
        console.log(error);
        self.setState({ isActive: false });
        Swal.fire({
          title: 'Error!',
          text: 'Please try again later!',
          icon: 'error',
          confirmButtonText: 'Ok'
        })

      });

  }


  render() {
    let self = this;
    let commentNodes = this.state.events.map(function (event, index) {
      if(index<3)
      {
      return <div key={index}>
        <br />
        <div className="card">
          <div className="card-body">
            <div className="row">
              <div className="col-md-3" style={{ marginTop: '25px' }}>
                <img src="https://media-cdn.tripadvisor.com/media/photo-s/01/1d/05/ff/nice-swimming-pool.jpg" />
              </div>
              <div className="col-md-6  card-body">
                <div className="list-title">
                  <ul className="list-inline list-unstyled">
                    <li className="list-inline-item"><a href="#"><h4>{event.event_name}</h4></a></li>
                  </ul>
                </div>
                <div className="list-location">
                  <a href="#"><i className="fa fa-map-marker" /><small> {event.stadium_name_en}</small> </a>
                </div>
                <div className="list-descrip">
                  <small>
                    {event.event_description}                                                              </small>
                </div>
              </div>
              <div className="col-md-3 border-left card-body">
                <button type="button" Style={{width:'100%'}} className="btn btn-outline-primary" onClick={e => self.eventDetails(e, event.event_id, event.stadium_id)}>Edit Event</button>
              </div>
            </div>
          </div>
        </div>
      </div>;
      }
    });
    return (
      <LoadingOverlay
        active={this.state.isActive}
        spinner
        text='Loading ...'
      >
        <div style={{ backgroundColor: 'grey' }}>

          <Navbar />


          <div className="container">
            <br />
            <div className="card py-3">
              <div className="row">
                <div className="mx-auto col-sm-9">
                  <div className="card">

                    <div className="card-body">

                      <div className="row">
                        <div className="col-sm-6">
                          <h4 className="text-muted"> Book a new Sports Event</h4>
                        </div>
                        <div className="col-sm-6 text-center">
                          <button className="btn btn-primary" onClick={this.createevent}>Create Now</button>
                        </div>
                      </div>

                    </div>

                  </div>


                  <br />

                  <div className="row">
                    <div onClick={e => this.setState({ page: 1 })} className={this.state.page === 1 ? "col-sm-4 tab-selected text-center" : "col-sm-4 tab-unselected text-center"}><h3>My Profile</h3></div>
                    <div onClick={e => this.setState({ page: 2 })} className={this.state.page === 2 ? "col-sm-4 tab-selected text-center" : "col-sm-4 tab-unselected text-center"}><h3>My Bookings</h3></div>
                    <div className="col-sm-4 tab-end-unselected text-center"><h3>Notifications</h3></div>
                  </div>
                  {this.state.page === 1 &&



                    <div className="">

                      <div className=" ">
                        <div className="">
                          <div className="row">
                            <div className="col-sm-3 tab-contents-left" style={{ margin: '0px !important' }}>

                              <br />

                              <div className="text-center">
                                <img src="http://ssl.gstatic.com/accounts/ui/avatar_2x.png" className="avatar img-circle img-thumbnail" alt="avatar" />
                                <br />
                                <input type="file" className="text-center center-block file-upload" />
                              </div>
                              <br />

                            </div>
                            <div className="col-sm-9  tab-contents-out">
                              <div><br />
                                <h4>
                                  Personal Info</h4>
                                <fieldset>

                                  {/* Name */}
                                  <div className="form-group">
                                    <div className="col-xs-6">
                                      <label htmlFor="password2"><h5>Name</h5></label>
                                      <input type="text"
                                        name="email_id" placeholder="Enter Name"
                                        defaultValue={localStorage.getItem('userEmail')}
                                        className="form-control" style={{ width: '310px' }} />
                                    </div>
                                  </div>
                                  {/* Card Number */}
                                  <div className="form-group">
                                    <div className="col-xs-6">
                                      <label htmlFor="password2"><h5>Email</h5></label>
                                      <input type="text"
                                        name="email_id" placeholder="Enter Email"
                                        defaultValue={localStorage.getItem('userEmail')}
                                        className="form-control" style={{ width: '310px' }} />
                                    </div>
                                  </div>

                                  <br />
                                  {/* Submit */}
                                  <div className="control-group">
                                    <div className="controls">
                                      <button className="btn btn-success">Update</button>
                                    </div>
                                  </div>
                                </fieldset>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br></br>
                    </div>


                  }
                  {this.state.page === 2 &&



                    <div className="">

                      <div className=" ">
                        <div className="">
                          <div className="row">
                            <div className="col  tab-contents-out">
                              <div className="FixedHeightContainer">
                                <br />
                                <div className="Content">
                                  {commentNodes}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <br></br>
                    </div>


                  }
                </div>
              </div>
            </div>
          </div>
          <br/>
          <Footer />
        </div >
      </LoadingOverlay >
    )
  }
}
export default withRouter(Profile);
